/* eslint-disable react/no-array-index-key */
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { Helmet } from 'react-helmet';
import { defineMessages, injectIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { isMessage } from '../../lib/utils';

const messages = defineMessages({
    title: {
        id: 'meta.title_full',
        defaultMessage: '{title} | Entends-tu ce que je te dis? Kouté mwen titak!',
    },
});

const propTypes = {
    page: AppPropTypes.page,
    intl: AppPropTypes.intl.isRequired,
    title: AppPropTypes.text,
};

const defaultProps = {
    page: null,
    title: messages.title,
};

const PageMeta = ({ page, intl, title }) => {
    const realTitle =
        isMessage(title) && page !== null && page.title
            ? intl.formatMessage(title, { title: page.title })
            : 'Entends-tu ce que je te dis? Kouté mwen titak!';
    const { sharingText: description = '', sharingImageLarge: image = '', fullUrl: url } =
        page || {};

    return (
        <Helmet>
            <title>{realTitle}</title>
            {!isEmpty(description) ? <meta name="description" content={description} /> : null}
            <meta property="og:title" content={realTitle} />
            {!isEmpty(image) && !isObject(image) ? (
                <meta property="og:image" content={image} />
            ) : null}
            {isObject(image) && !isEmpty(image.url || null) ? (
                <meta property="og:image" content={image.url} />
            ) : null}
            <meta property="og:type" content="website" />
            {!isEmpty(description) ? (
                <meta property="og:description" content={description} />
            ) : null}
            <meta property="og:url" content={url} />
        </Helmet>
    );
};

PageMeta.propTypes = propTypes;
PageMeta.defaultProps = defaultProps;

export default React.memo(injectIntl(PageMeta));
